<template>
  <section class="content">
  </section>
</template>
<script>

export default {
    name: 'Help',
    
}

</script>
<style>
.lblWrong{
    color: red
}
</style>




// WEBPACK FOOTER //
// help.vue?c0740832